//@ts-check

import styled from '@emotion/styled';
import { Upload } from 'antd';
import React, { useMemo } from 'react';

const { Dragger } = Upload;

/**
 * @typedef {object} CustomFileUploadProps
 * @property {string} [pureCss]
 * @property {boolean} [listFileOnly]
 * @property {React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & { pureCss?: string }} [wrapper]
 * @property {import('antd/lib/upload').DraggerProps} [upload]
 * @property {React.ReactNode} [children]
 */

/**
 * @type {React.ForwardRefExoticComponent<CustomFileUploadProps & React.RefAttributes<HTMLDivElement>>}
 */
const FileUpload = React.forwardRef(
  ({ pureCss, wrapper = {}, listFileOnly, ...props }, ref) => {
    const WrapperStyle = useMemo(
      () => styled.div`
        ${wrapper?.pureCss || ''}
      `,
      [wrapper?.pureCss],
    );

    const DraggerStyle = useMemo(
      () => styled(Dragger)`
        ${listFileOnly
          ? `border: none !important;
            cursor: default !important;
            & > span {
              cursor: default !important;
            }
            input {
             display: none;
            }
                        
          `
          : `border: 2px dashed #d9d9d9 !important;`}
        ${pureCss || ''}
      `,
      [pureCss, listFileOnly],
    );

    return (
      <WrapperStyle ref={ref} {...wrapper}>
        <DraggerStyle {...props.upload}>{props.children}</DraggerStyle>
      </WrapperStyle>
    );
  },
);

export default FileUpload;
